<template>
  <div class="header">
    <div class="header__wrapper">
      <SvgIcon class="header__menu-icon" :icon="isMenuOpen ? 'menu-close' : 'menu'" @click="toggleMenu" />
      <div
        v-if="isMenuOpen"
        class="header__menu-wrapper"
        @click.self="toggleMenu"
      >
        <ul
          class="header__menu-list"
        >
          <li class="header__menu-item">
            <a href="https://inflowbusiness.ru/#Advantages">Преимущества</a>
          </li>
          <li class="header__menu-item">
            <a href="https://inflowbusiness.ru/#Integrations">Интеграции</a>
          </li>
          <li class="header__menu-item">
            <a href="https://inflowbusiness.ru/#Reviews">Отзывы</a>
          </li>
          <li class="header__menu-item">
            <a href="https://inflowbusiness.ru/#Possibilities">Возможности</a>
          </li>
          <li class="header__menu-item">
            <a href="https://inflowbusiness.ru/#Successfulcases">Успешные кейсы</a>
          </li>
        </ul>
      </div>
      <a href="https://inflowbusiness.ru" class="header__logo">Inflow <br> Business</a>
      <a v-if="!mainStore.isMobile" href="tel:88002017211" class="header__phone">
        <SvgIcon icon="phone" />
        <span>8 (800) 201 7211</span>
      </a>
      <div v-if="!mainStore.isMobile" class="header__contacts">
        <div class="header__social">
          <a href="https://t.me/+79316242356" target="_blank"><SvgIcon icon="tg" /></a>
        </div>
        <!--        <div class="header__feedbacks" :class="[{ active: isOpenContact }]" @click="toggleContact"> -->
        <!--          Связаться с нами <SvgIcon icon="chevron-down" /> -->
        <!--        </div> -->
        <!--        <div v-if="isOpenContact" class="header__hover" @click.self="toggleContact"> -->
        <!--          <a v-if="!mainStore.isMobile" href="tel:898856857566" class="header__phone &#45;&#45;popup"> -->
        <!--            <SvgIcon icon="phone" /> -->
        <!--            <span>8 988 568 575 66</span> -->
        <!--          </a> -->
        <!--          <a v-if="!mainStore.isMobile" href="tel:898856857566" class="header__phone &#45;&#45;popup"> -->
        <!--            <SvgIcon icon="phone" /> -->
        <!--            <span>8 988 568 575 66</span> -->
        <!--          </a> -->
        <!--          <div class="header__social"> -->
        <!--            <a href="https://t.me/+79316242356" target="_blank"><SvgIcon icon="tg" /></a> -->
        <!--            <a href="https://t.me/+79316242356" target="_blank"><SvgIcon icon="wa" /></a> -->
        <!--          </div> -->
        <!--        </div> -->
      </div>
      <div class="header__actions">
        <!--        <a v-if="!mainStore.isMobile" class="header__actions-home" href="#" target="_blank">ИИ-ассистенты</a> -->
        <a class="header__actions-enter" href="https://panel.inflowbusiness.ru" target="_blank">Войти</a>
      </div>
    </div>
  </div>
</template>

<script lang="ts" src="./AppHeader.ts">
</script>

<style lang="scss" src="./AppHeader.scss"></style>
